'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="px-5 py-32 sm:px-12">
      <div className="prose mx-auto">
        <h1>Une erreur est survenue</h1>
        <button
          className="bg-secondary hover:bg-primary hover:text-secondary mt-5 inline-block cursor-pointer rounded-md border border-transparent px-8 py-3 font-medium text-white duration-100"
          onClick={() => reset()}
        >
          Réessayer
        </button>
      </div>
    </div>
  );
}
